$(document).ready(function() {
  var animated = false; // Flag to ensure animation runs only once

  function isElementInView(element) {
    var elementTop = element.offset().top;
    var elementBottom = elementTop + element.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  function animateNumbers() {
    $('.number-run').each(function() {
      var $this = $(this);
      var targetNumber = parseInt($this.text(), 10);
      var currentNumber = 0;
        var increment = targetNumber / (50 + Math.floor(Math.random() * 50)); // Random increment for unique animation

      var timer = setInterval(function() {
        currentNumber += increment;
        if (currentNumber >= targetNumber) {
          currentNumber = targetNumber;
          clearInterval(timer);
        }
        $this.text(Math.round(currentNumber));
      }, 25);
    });
  }
    var $section = $('#shopify-section-template--15415806197873__7ff78395-d65e-4b6f-87d1-ee5f518424d8');  
      if (!animated && isElementInView($section)) {
      animateNumbers();
      animated = true; // Set the flag so it doesn't animate again
    }
  $(window).on('scroll', function() {
    if (!animated && isElementInView($section)) {
      animateNumbers();
      animated = true; // Set the flag so it doesn't animate again
    }
  });
$('.menu-container li').click(function(event) {
  if (event.target.hasClass('.main-nav-link') === false) {
    $('.menu-container').removeClass('open-menu');
  }
});
});